export default "__VITE_ASSET__CPihaFie__"